import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue';
    import type { ChangedFields, Employee } from '@/types';
    import EmployeeChangesGroup from '../EmployeeChangesGroup.vue';
    import { useI18n } from 'vue-i18n';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'OptionalTab',
  props: {
    employee: {},
    data: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const values = computed(() => {
        return [
            ...(props.data?.old?.has_lunch_arrangement
                ? [
                      {
                          name: 'has_lunch_arrangement',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.has_lunch_arrangement?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.has_lunch_arrangement
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.has_fixed_add_ons
                ? [
                      {
                          name: 'has_fixed_add_ons',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.has_fixed_add_ons?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.has_fixed_add_ons
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.has_free_phone
                ? [
                      {
                          name: 'has_free_phone',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.has_free_phone?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.has_free_phone
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.has_free_car
                ? [
                      {
                          name: 'has_free_car',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.has_free_car?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.has_free_car
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.danmarks_statistik
                ? [
                      {
                          name: 'danmarks_statistik',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.danmarks_statistik?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.danmarks_statistik
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.has_pension
                ? [
                      {
                          name: 'has_pension',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.has_pension?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.has_pension
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.kilometer
                ? [
                      {
                          name: 'kilometer',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.kilometer?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.kilometer
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.diaeter
                ? [
                      {
                          name: 'diaeter',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.diaeter?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.diaeter
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
            ...(props.data?.old?.health_insurance
                ? [
                      {
                          name: 'health_insurance',
                          group: 'optional',
                          key: 'optional',
                          oldValue: props.data?.old?.health_insurance?.value
                              ? t('forms.yes')
                              : t('forms.no'),
                          realValue: props.employee.optional?.health_insurance
                              ? t('forms.yes')
                              : t('forms.no'),
                      },
                  ]
                : []),
        ];
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(EmployeeChangesGroup, {
    data: _ctx.data,
    values: values.value,
    employee: _ctx.employee
  }, null, 8, ["data", "values", "employee"]))
}
}

})